const NEWSLETTER_ENDPOINT =
  "https://bhzkptvrqcopwphmemga.supabase.co/functions/v1/subscribe-newsletter";

export const NEWSLETTER_DISMISSED_AT_KEY =
  "archiveNewsletterPromptDismissedAt";
export const NEWSLETTER_SUBSCRIBED_KEY = "archiveNewsletterSubscribed";
export const NEWSLETTER_SHOWN_SESSION_KEY =
  "archiveNewsletterPromptShownThisSession";

export const NEWSLETTER_DISMISSAL_DAYS = 15;

function readStorage(storage, key) {
  try {
    return storage?.getItem(key) || "";
  } catch {
    return "";
  }
}

function writeStorage(storage, key, value) {
  try {
    storage?.setItem(key, value);
  } catch {
    // The subscription flow should still work when browser storage is blocked.
  }
}

export function hasNewsletterSubscription() {
  if (typeof window === "undefined") return false;
  return (
    readStorage(window.localStorage, NEWSLETTER_SUBSCRIBED_KEY) === "true"
  );
}

export function isNewsletterPromptDismissed() {
  if (typeof window === "undefined") return false;

  const dismissedAt = Number(
    readStorage(window.localStorage, NEWSLETTER_DISMISSED_AT_KEY)
  );
  if (!Number.isFinite(dismissedAt) || dismissedAt <= 0) return false;

  const dismissalWindow =
    NEWSLETTER_DISMISSAL_DAYS * 24 * 60 * 60 * 1000;
  return Date.now() - dismissedAt < dismissalWindow;
}

export function wasNewsletterPromptShownThisSession() {
  if (typeof window === "undefined") return false;
  return (
    readStorage(window.sessionStorage, NEWSLETTER_SHOWN_SESSION_KEY) === "true"
  );
}

export function markNewsletterPromptShown() {
  if (typeof window === "undefined") return;
  writeStorage(window.sessionStorage, NEWSLETTER_SHOWN_SESSION_KEY, "true");
}

export function markNewsletterPromptDismissed() {
  if (typeof window === "undefined") return;
  writeStorage(
    window.localStorage,
    NEWSLETTER_DISMISSED_AT_KEY,
    Date.now().toString()
  );
}

export function markNewsletterSubscribed({ notify = true } = {}) {
  if (typeof window === "undefined") return;
  writeStorage(window.localStorage, NEWSLETTER_SUBSCRIBED_KEY, "true");
  try {
    window.localStorage.removeItem(NEWSLETTER_DISMISSED_AT_KEY);
  } catch {
    // Ignore storage restrictions after a successful server response.
  }
  if (notify) {
    window.dispatchEvent(new CustomEvent("archive:newsletter-subscribed"));
  }
}

export function shouldSuppressNewsletterPrompt() {
  return (
    hasNewsletterSubscription() ||
    isNewsletterPromptDismissed() ||
    wasNewsletterPromptShownThisSession()
  );
}

export async function subscribeToNewsletter({ email, language }) {
  const response = await fetch(NEWSLETTER_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, language, company: "" }),
  });
  const result = await response.json().catch(() => ({}));

  if (!response.ok || !result.ok) {
    const error = new Error("Newsletter subscription failed");
    error.code = result.code || "subscription_error";
    throw error;
  }

  return result;
}
